export const APP_NAME = 'SmartCaf'
export const ADMIN_AUTH_PREFIX_PATH = '/admin'
export const ADMIN_PREFIX_PATH = '/admin/dashboard'